import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "../../../components/buttons/buttons";
import { Beat } from "../../../plugins/spinners.plugin";
import Input from "../../../components/inputs/inputs";
import SelectableInput from "../../../components/inputs/SelectableInput";
import Location from "../../../components/includes/location";
import LocationSearch from "../../../components/includes/locationSearch";
import { history } from "../../../helpers/history";
import { getUserBusinessIdFromCookies } from "../../../utils/Auth";
import { logoutUserLocallyAction } from "../../../plugins/axios.plugin";
import { createRestaurantAction } from "../../../redux/restaurant/restaurantActions";
import { filterProductCategory } from "../../../redux/productCatergory/productCategoryAction";
import { getAllCategories } from "../../../redux/productCatergory/productCategoryAction";
import { getAllTags } from "../../../redux/productTags/productTagActions";
import { showApplication } from "../../../redux/applicationSettings/applicationAction";

export default function CreateRestaurant() {
  const dispatch = useDispatch();
  const user_business_id = getUserBusinessIdFromCookies();

  const business_id = user_business_id || "";

  const { allCategories } = useSelector((state) => state.productCatergory);
  const { allTags } = useSelector((state) => state.productTag);
  const { isLoading } = useSelector((state) => state.restaurant);
  const { settings } = useSelector((state) => state.application);

  const useGooglePlaces = settings?.google_places_status === "available";

  const [submitted, setSubmitted] = useState(false);
  const [locationLoader, setLocationLoader] = useState(false);

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  const [data, setData] = useState({
    restaurant_email: "",
    restaurant_name: "",
    restaurant_address: "",
    restaurant_city: "",
    restaurant_state: "",
    restaurant_country: "",
    restaurant_categories: [],
    restaurant_tags: [],
    restaurant_description: "",
    restaurant_phone: "",
  });
  const {
    restaurant_name,
    restaurant_email,
    restaurant_address,
    restaurant_city,
    restaurant_state,
    restaurant_country,
    restaurant_description,
    restaurant_categories,
    restaurant_tags,
  } = data;

  let { restaurant_phone } = data;

  useEffect(() => {
    dispatch(showApplication());
    dispatch(getAllCategories());
    dispatch(getAllTags());
    dispatch(filterProductCategory({ type: "restaurant" }, 1));
    // eslint-disable-next-line
  }, []);
  const restaurantCategories = allCategories?.data?.filter((item) => {
    return item?.type === "restaurant";
  });
  const restaurantTags = allTags?.data?.filter((item) => {
    return item?.type === "restaurant";
  });

  //This is used to set location if google places is active
  const handleSelectLocation = (place) => {
    setData((prev) => ({
      ...prev,
      restaurant_address: place.address,
      restaurant_city: place.city,
      restaurant_state: place.state,
      restaurant_country: place.country,
      restaurant_latitude: place.lat,
      restaurant_longitude: place.lng,
      restaurant_zip: place.postalCode,
    }));
  };

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "restaurant_categories") {
      setData({ ...data, restaurant_categories: [value] });
    } else {
      setData((data) => ({ ...data, [name]: value }));
    }
  };

  const handleAddTags = (value) => {
    const former_tags = [...data?.restaurant_tags];
    let new_tags = [...former_tags, value.name];
    setData({ ...data, restaurant_tags: new_tags });
  };

  const handleAddCategories = (value) => {
    const former_categories = [...data?.restaurant_categories];
    let new_categories = [...former_categories, value.name];
    setData({ ...data, restaurant_categories: new_categories });
  };

  const handlePhone = (e) => {
    let phone = e;
    restaurant_phone = phone?.slice(1);
    setData({ ...data, restaurant_phone: restaurant_phone });
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    if (
      restaurant_name &&
      restaurant_phone &&
      restaurant_address &&
      restaurant_categories &&
      restaurant_city &&
      restaurant_state &&
      restaurant_country
    ) {
      const response = await dispatch(
        createRestaurantAction({ ...data, business_id: business_id })
      );
      if (response.status === "success") {
        logoutUserLocallyAction();
        history("/success");
      }
    }
  };

  return (
    <div>
      <div
        className="pt-4 sm:pt-2 sm:flex items-center mx-auto"
        data-test="restaurantComponent"
      >
        <div className=" max-w-4xl mx-auto mt-10">
          <div className="sm:w-[629px] w-full mt-10 sm:ml-10 sm:mt-0 sm:border px-6 pb-4 sm:border-gray-200 dark:border-none dark:bg-[#121212]">
            <form name="form">
              <div className="border-b-2 py-4 mb-6">
                <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
                  Restaurant Details
                </p>
              </div>

              <div className=" sm:px-10">
                <div
                  className={
                    "mt-4" +
                    (submitted && !restaurant_name ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Restaurant Name"}
                    htmlFor={"restaurant_name"}
                    type={"text"}
                    name={"restaurant_name"}
                    onChange={handleChange}
                    placeholder={"Enter restaurant name"}
                  />
                  {submitted && !restaurant_name && (
                    <div className="text-xs text-red-500">
                      Restaurant name is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && !restaurant_email ? " border-red-500" : "")
                  }
                >
                  <Input.Label
                    title={"Restaurant Email *"}
                    htmlFor={"restaurant_email"}
                    type={"email"}
                    name={"restaurant_email"}
                    onChange={handleChange}
                    placeholder={"Enter restaurant email address"}
                  />
                  {submitted && !restaurant_email && (
                    <div className="text-xs text-red-500">
                      Restaurant email is required
                    </div>
                  )}
                </div>
                <div
                  className={
                    "mt-4" +
                    (submitted && !restaurant_phone ? " border-red-500" : "")
                  }
                >
                  <Input.Phone
                    defaultCountry="NG"
                    title={"Restaurant Phone Number*"}
                    htmlFor={"restaurant_phone"}
                    value={restaurant_phone}
                    onChange={(e) => handlePhone(e)}
                  />
                  {submitted && !restaurant_phone && (
                    <div className="text-xs text-red-500">
                      Restaurant phone is required
                    </div>
                  )}
                </div>
                {useGooglePlaces && (
                  <div className="my-5">
                    <LocationSearch onPlaceSelect={handleSelectLocation} />
                  </div>
                )}
                <div className={useGooglePlaces ? "hidden" : ""}>
                  <div
                    className={
                      "mt-4" +
                      (submitted && !restaurant_address
                        ? " border-red-500"
                        : "")
                    }
                  >
                    <Input.Label
                      title={"Restaurant Address *"}
                      htmlFor={"restaurant_address"}
                      type={"text"}
                      name={"restaurant_address"}
                      onChange={handleChange}
                      placeholder={"Enter Restaurant Address"}
                    />
                    {submitted && !restaurant_address && (
                      <div className="text-xs text-red-500">
                        Restaurant address is required
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_description
                      ? " border-red-500"
                      : "")
                  }
                >
                  <Input.TextArea
                    title={"Restaurant Description "}
                    htmlFor={"restaurant_description"}
                    type={"text"}
                    name={"restaurant_description"}
                    onChange={handleChange}
                    placeholder={"Describe your restaurant to us"}
                  />
                </div>

                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_categories
                      ? " border-red-500"
                      : "")
                  }
                >
                  <label
                    htmlFor="restaurant_categories"
                    className="text-sm font-medium text-[#151515] dark:text-white"
                  >
                    Restaurant Categories*
                  </label>
                  <SelectableInput
                    options={restaurantCategories}
                    label="restaurant_categories"
                    name={"+ Add Category"}
                    type="category"
                    selectOption={handleAddCategories}
                  />
                </div>

                <div
                  className={
                    "mt-4" +
                    (submitted && restaurant_tags ? " border-red-500" : "")
                  }
                >
                  <label
                    htmlFor="restaurant_tags"
                    className="text-sm font-medium text-[#151515] dark:text-white"
                  >
                    Restaurant Tags*
                  </label>
                  <SelectableInput
                    options={restaurantTags}
                    label="restaurant_tags"
                    name={"+ Add Tag"}
                    type="tag"
                    selectOption={handleAddTags}
                  />
                </div>

                <Location
                  country_id={locationId.country_id}
                  state_id={locationId.state_id}
                  city_id={locationId.city_id}
                  loadingLocation={(value) => {
                    setLocationLoader(value);
                  }}
                  countryList={(value) => {
                    setLocationList({ ...locationList, countryList: value });
                  }}
                  stateList={(value) => {
                    setLocationList({ ...locationList, stateList: value });
                  }}
                  cityList={(value) => {
                    setLocationList({ ...locationList, cityList: value });
                  }}
                />
                {useGooglePlaces && (
                  <div className="my-5">
                    <LocationSearch
                      onPlaceSelect={handleSelectLocation}
                      searchLocationTitle={"Search Restaurant Location*"}
                    />
                  </div>
                )}
                <div className={useGooglePlaces ? "hidden" : ""}>
                  <div className="mt-4">
                    <Input.Select
                      title={"Select Country*"}
                      name="country"
                      id="country"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"country"}
                      value={restaurant_country}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          country_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {restaurant_country !== ""
                          ? restaurant_country
                          : "Select Country"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.countryList &&
                        locationList?.countryList?.length > 0 &&
                        locationList?.countryList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                              className="dark:bg-[#121212] dark:text-white"
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !restaurant_country && (
                      <div className="text-xs text-red-500">
                        Country is required
                      </div>
                    )}
                  </div>

                  <div className="mt-4">
                    <Input.Select
                      title={"Select State*"}
                      name="state"
                      id="state"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"state"}
                      value={restaurant_state}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          state_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {restaurant_state !== ""
                          ? restaurant_state
                          : "Select State"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.stateList &&
                        locationList?.stateList?.length > 0 &&
                        locationList?.stateList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !restaurant_state && (
                      <div className="text-xs text-red-500">
                        State is required
                      </div>
                    )}
                  </div>

                  <div className="mt-4 mb-10">
                    <Input.Select
                      title={"Select City*"}
                      name="city"
                      id="city"
                      className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                      htmlFor={"city"}
                      value={restaurant_city}
                      disabled={useGooglePlaces}
                      onChange={(e) => {
                        setLocationId({
                          ...locationId,
                          city_id: fromJson(e.target.value).id,
                        });
                        handleRegion(e);
                      }}
                    >
                      <option>
                        {restaurant_city !== ""
                          ? restaurant_city
                          : "Select City"}
                      </option>
                      {locationLoader ? (
                        <option>Loading...</option>
                      ) : (
                        locationList?.cityList &&
                        locationList?.cityList?.length > 0 &&
                        locationList?.cityList?.map((item, key) => {
                          return (
                            <option
                              key={key}
                              value={toJson({
                                name: item.name,
                                id: item.id,
                              })}
                            >
                              {item.name}
                            </option>
                          );
                        })
                      )}
                    </Input.Select>
                    {submitted && !restaurant_city && (
                      <div className="text-xs text-red-500">
                        City is required
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>

          <Button.Primary
            title={isLoading ? <Beat color={"#ffffff"} /> : "Submit"}
            className={"w-[333px] sm:mt-10 mx-auto flex justify-center"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}
